import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { SparkLinePointDtoSchema } from '../contracts';

const _GetTotalStaffRequestDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
  facilitiesIds: z.array(z.number()).optional(),
});

const GetTotalStaffResponseDtoSchema = z.object({
  sparkline: z.object({
    granularity: z.enum(['day', 'week', 'month']),
    points: z.array(SparkLinePointDtoSchema),
  }),
  totalStaff: z.number().nullable(),
  changePct: z.number().nullable(),
});

export type GetTotalStaffRequestDto = z.infer<
  typeof _GetTotalStaffRequestDtoSchema
>;
export type GetTotalStaffResponseDto = z.infer<
  typeof GetTotalStaffResponseDtoSchema
>;

export const getTotalStaff = (
  params: GetTotalStaffRequestDto,
  config?: AxiosRequestConfig<GetTotalStaffRequestDto>
) => {
  return api
    .get('/staff/total-staff', {
      params,
      ...config,
    })
    .then(responseContract(GetTotalStaffResponseDtoSchema));
};
